import api from './api';

export const getDriverLimitInfo = async () => {
  const res = await api.get('/transporteur/driver-limit');
  return res.data; // { limit, count }
};

export const getTransporteurs = async (q) => {
  const res = await api.get('/admin/transporteurs', { params: { q } });
  return res.data;
};

// limits: { chauffeurLimit: number, vehiculeLimit: number }
export const updateTransporteurLimit = async (id, limits) => {
  // Pass object directly. Backend handles { chauffeurLimit, vehiculeLimit } keys.
  const res = await api.put(`/admin/transporteurs/${id}/limit`, limits);
  return res.data;
};

export const getIncidents = async (transporteurId) => {
  const res = await api.get('/transporteur/incidents', {
    params: { transporteurId }
  });
  return res.data;
};

export const getDashboardStats = async (transporteurId) => {
  const res = await api.get('/transporteur/dashboard-stats', {
    params: { transporteurId }
  });
  return res.data;
};

export const getRecentMissions = async (transporteurId) => {
  const res = await api.get('/transporteur/recent-missions', {
    params: { transporteurId }
  });
  return res.data;
};

// Responsable transporteur endpoints
export const getChildTransporteurs = async () => {
  const res = await api.get('/responsable/transporteurs');
  return res.data;
};

export const createChildTransporteur = async (payload) => {
  const res = await api.post('/responsable/transporteurs', payload);
  return res.data;
};

export const updateChildTransporteur = async (id, payload) => {
  const res = await api.put(`/responsable/transporteurs/${id}`, payload);
  return res.data;
};

export const deleteChildTransporteur = async (id) => {
  const res = await api.delete(`/responsable/transporteurs/${id}`);
  return res.data;
};

const transporteurService = {
  getDriverLimitInfo,
  getTransporteurs,
  updateTransporteurLimit,
  getIncidents,
  getDashboardStats,
  getRecentMissions,
  getChildTransporteurs,
  createChildTransporteur,
  updateChildTransporteur,
  deleteChildTransporteur,
};

export default transporteurService;

